export default __webpack_public_path__ + "static/media/landing-demo-team.71a54061.svg";